/** @format */

import { QualificationId, Qualifications, ResourceLink } from "../types";
import i18next from "i18next";
import { Subject } from "../app/services/subjectApi";

/**
 * @return Converts the raw id of a qualification to a human readable form
 */
export const qualIdToFull = (qual: QualificationId | undefined): string => {
  // TODO: needs tests?
  switch (qual) {
    case "gcse":
      return i18next.t("GCSE");
    case "alevel":
      return i18next.t("A Level");
    case "mfwGcse":
      return i18next.t("Made for Wales GCSE");
    case "mfwAlevel":
      return i18next.t("Made for Wales A Level");
    case "mfwVq":
      return i18next.t("Made for Wales Vocational Qualification");
    case "vqMultiLevel":
      return i18next.t("Vocational Qualification Multi Level");
    case "vqEntryPath":
      return i18next.t("Vocational Qualification Entry Path");
    case "vqLevel12":
      return i18next.t("Vocational Qualification Level 1/2");
    case "vqLevel23":
      return i18next.t("Vocational Qualification Level 2/3");
    case "vqLevel3":
      return i18next.t("Vocational Qualification Level 3");
    case "vq":
      return i18next.t("Vocational Qualification");
    case "asbwales":
      return i18next.t("Advanced Skills Baccalaureate Wales");
    case "qdo":
      return i18next.t("Qualification Development");
    case undefined:
      return "";
    default:
      // Idk if this could happen, but if it does, leave string as is
      return qual as string;
  }
};

/**
 * @return true if the inputted string begins with 'https://'
 */
export const isSecureLink = (link: string): boolean => {
  return link.substring(0, 8) === "https://";
};

/**
 * Wrapper to check that both a link is not undefined and its secure
 * Also returns true if the string is empty - useful for form validation where no link is a secure link
 */
export const isSecureLinkUndefinedWrapper = (
  link: string | undefined,
): boolean => {
  return link !== undefined && (link === "" || isSecureLink(link));
};

/**
 * @param qualInp a qualification id. e.g. alevel
 * @return an array of required keystages for the given qualification. Returns empty if qualification not found or it
 *  has no keystages
 */
export const getQualificationKeystages = (qualInp: string): string[] => {
  let data;
  try {
    data = require(`../json/qualifications.json`);
  } catch {
    console.log("failed to fetch qualifications");
    return [];
  }

  try {
    const qualification: Qualifications = data.find(
      (qual: Qualifications) => qual.code === qualInp,
    );
    return qualification.keyStage || [];
  } catch {
    return [];
  }
};

/**
 * @param subjectName the raw name of the subject in the language specified by locale
 * @param locale the language of the subjectName
 * @param subjects the list of subjects to be searched
 * @return the id of the subject specified or "" if not found
 */
export const subjectNameToId = (
  subjectName: string,
  subjects: Subject[] | undefined,
): string => {
  if (!subjects) return "";
  if (subjectName === "") return "";

  return (
    subjects.find(
      (sub) =>
        sub.title["en"] === subjectName || sub.title["cy"] === subjectName,
    )?.id ?? ""
  );
};

export const subjectFromId = (
  subjectId: string,
  subjects: Subject[] | undefined,
): Subject | undefined => {
  return subjects?.find((sub) => sub.id === subjectId);
};

export const getUniqueCategories = (links: ResourceLink[]): string[] => {
  let tempCats: string[] = [];
  links.forEach((link) => {
    if (link.category && !tempCats.includes(link.category))
      tempCats.push(link.category);
  });

  return tempCats;
};
